<script setup>
import PlanCard from "./PlanCard.vue";
import PlansModalBase from "./PlansModalBase.vue";

import { defineProps, defineEmits, computed } from "vue";
import { useI18n } from "vue-i18n";

const { tm } = useI18n();

const { open, plans, userData } = defineProps([
  "open",
  "plans",
  "userData",
]);
const emit = defineEmits(["close"]);


const plansBenefits = computed(() => tm("billing.plans_benefits2"));

// Filter out plans with missing essential data
const validPlans = computed(() => {
  if (!plans || !Array.isArray(plans)) return [];

  return plans.filter(plan => {
    return plan &&
           plan.id &&
           plan.name &&
           plan.currency_symbol &&
           (plan.unit_price !== undefined && plan.unit_price !== null) &&
           (plan.price !== undefined && plan.price !== null);
  });
});
</script>
<template>
  <PlansModalBase :open="open" @close="emit('close')">
    <PlanCard
      v-for="(plan, index) in validPlans"
      :key="plan?.id || index"
      :plan="plan"
      :plansBenefits="plansBenefits[plan.type]"
      :userData="userData"
      @closeModal="emit('close')"
    />
  </PlansModalBase>
</template>
